(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../_util'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../_util'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._util);
    global.picker = mod.exports;
  }
})(this, function (exports, _util) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    props: {
      value: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      describe: {
        type: String,
        default: ''
      },
      position: {
        type: String,
        default: 'bottom'
      },
      lockScroll: {
        type: Boolean,
        default: true
      },
      hasMask: {
        type: Boolean,
        default: true
      },
      maskClosable: {
        type: Boolean,
        default: false
      },
      transition: {
        type: String,
        default: 'nx-slide-up'
      },
      swipeTime: {
        type: Number,
        default: 2500
      },
      okText: {
        type: String,
        default: '确定'
      },
      cancelText: {
        type: String,
        default: '取消'
      },
      slideDownDisappear: {
        default: undefined
      },
      backClosePopup: {
        type: Boolean,
        default: false
      },
      backClosePopupCustomEvent: {
        type: String,
        default: 'popstate'
      },
      isWebviewFull: {
        type: Boolean,
        default: function _default() {
          return _util.isCombineWallet && location.href && location.href.indexOf('sink=1') > -1;
        }
      }
    }
  };
});